export let StudentPage = /*#__PURE__*/function (StudentPage) {
  StudentPage["MY_ASSIGNMENTS"] = "my-assignments";
  StudentPage["MY_TESTS"] = "my-tests";
  StudentPage["MY_STUDY_MATERIALS"] = "my-study-materials";
  StudentPage["MY_FEEDBACKS"] = "my-feedbacks";
  StudentPage["MY_ASSIGNED_STUDY_MATERIAL"] = "assigned-study-material";
  StudentPage["MY_QUESTIONS"] = "my-questions";
  StudentPage["MY_PLANS"] = "my-plans";
  StudentPage["MY_SCHEDULE"] = "my-schedule";
  StudentPage["MY_STUDY_RECORDS"] = "my-study-records";
  StudentPage["MY_RANKING"] = "my-ranking";
  StudentPage["MY_INFORMATION"] = "my-information";
  StudentPage["MY_CREDITS"] = "my-credits";
  StudentPage["LEVEL_TEST"] = "level-test";
  return StudentPage;
}({});
export let TeacherPage = /*#__PURE__*/function (TeacherPage) {
  TeacherPage["MAIN"] = "main";
  TeacherPage["CLASS"] = "my-class";
  TeacherPage["ASSIGNMENTS"] = "my-assignments";
  TeacherPage["TESTS"] = "my-tests";
  TeacherPage["STUDY_MATERIALS"] = "my-study-materials";
  TeacherPage["FEEDBACKS"] = "my-feedbacks";
  TeacherPage["ASSIGNED_STUDY_MATERIAL"] = "assigned-study-material";
  TeacherPage["QUESTIONS"] = "my-questions";
  TeacherPage["SCHEDULE"] = "schedule";
  TeacherPage["ROADMAP"] = "roadmap";
  TeacherPage["STUDY_RECORDS"] = "my-study-records";
  TeacherPage["RANKING"] = "my-ranking";
  TeacherPage["STUDY_CONTENT_REPORT"] = "my-study-content";
  TeacherPage["LEVEL_TEST"] = "level-test";
  TeacherPage["STUDENT_INFORMATION"] = "student-information";
  TeacherPage["COURSE_DETAIL"] = "course/detail";
  TeacherPage["CREDITS"] = "credits";
  TeacherPage["CONSULTATION"] = "consultation";
  TeacherPage["STUDY_CALENDAR"] = "study-calendar";
  return TeacherPage;
}({});